var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopupCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.578125,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFB6B6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_972_13009",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.57812,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_972_13009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9 21.5781L16.5 17.9781L20.1 21.5781L21.5 20.1781L17.9 16.5781L21.5 12.9781L20.1 11.5781L16.5 15.1781L12.9 11.5781L11.5 12.9781L15.1 16.5781L11.5 20.1781L12.9 21.5781ZM16.5 26.5781C15.1167 26.5781 13.8167 26.3155 12.6 25.7901C11.3833 25.2655 10.325 24.5531 9.425 23.6531C8.525 22.7531 7.81267 21.6948 7.288 20.4781C6.76267 19.2615 6.5 17.9615 6.5 16.5781C6.5 15.1948 6.76267 13.8948 7.288 12.6781C7.81267 11.4615 8.525 10.4031 9.425 9.50313C10.325 8.60313 11.3833 7.89046 12.6 7.36512C13.8167 6.84046 15.1167 6.57812 16.5 6.57812C17.8833 6.57812 19.1833 6.84046 20.4 7.36512C21.6167 7.89046 22.675 8.60313 23.575 9.50313C24.475 10.4031 25.1873 11.4615 25.712 12.6781C26.2373 13.8948 26.5 15.1948 26.5 16.5781C26.5 17.9615 26.2373 19.2615 25.712 20.4781C25.1873 21.6948 24.475 22.7531 23.575 23.6531C22.675 24.5531 21.6167 25.2655 20.4 25.7901C19.1833 26.3155 17.8833 26.5781 16.5 26.5781Z",
    fill: "#D95353"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupCloseIcon);
export default __webpack_public_path__ + "static/media/popup_close_icon.b8849a81bc30fad8e7603af7d6303ca7.svg";
export { ForwardRef as ReactComponent };